// src/components/forms/FormSection.js
// Card outlined OU flat section com title/description que agrupa fields
// relacionados em formulários (2026-05-11, Fase 12 + Fase 14.3).
//
// API:
//   title       — string ou ReactNode (h6 600)
//   description — opcional, body2 muted
//   variant     — 'flat' (default) | 'card'
//                 flat: sem Card outlined, ocupa AppContent inteiro, separação
//                       por borderTop + título. Forms grandes.
//                 card: Card outlined com maxWidth controlável (default 720),
//                       mx auto. Forms simples (auth-style).
//   maxWidth    — só usado em variant=card. Default 720.
//   children    — geralmente FormGrid + FormField

import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'

const FORM_SECTION_CARD_MAX_WIDTH = 720

export default function FormSection({
  title,
  description,
  children,
  variant = 'flat',
  maxWidth = FORM_SECTION_CARD_MAX_WIDTH,
  sx,
}) {
  const header = (title || description) && (
    <Box sx={{ mb: 2 }}>
      {title && (
        <Typography
          variant='h6'
          sx={{ fontWeight: 600, color: 'text.primary' }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>
          {description}
        </Typography>
      )}
    </Box>
  )

  if (variant === 'card') {
    return (
      <Card variant='outlined' sx={{ maxWidth, mx: 'auto', mb: 4, ...sx }}>
        <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
          {header}
          {children}
        </CardContent>
      </Card>
    )
  }

  // variant='flat' (default)
  return (
    <Box
      component='section'
      sx={{
        mb: 4,
        pt: 3,
        borderTop: '1px solid',
        borderColor: 'divider',
        ...sx,
      }}
    >
      {header}
      {children}
    </Box>
  )
}
